import { Link } from "react-router-dom";
import "./header.css";
import logo from "../../assets/prufyy-logo.png";

function Header() {
  return (
    <header className="header">
      {/* LEFT SIDE */}
      <div className="header-left">
        <Link to="/" className="logo">
          <img
            src={logo}
            alt="prufyy logo"
            className="logo-img"
          />
        </Link>

        <nav className="header-nav">
          {/* SOLUTIONS DROPDOWN */}
          <div className="header-dropdown">
            <span className="header-link dropdown-trigger">
              Solutions
            </span>

            <div className="dropdown-menu">
              <div className="dropdown-title">Who are you?</div>

              <Link to="/solutions/founder" className="dropdown-item">
                Founder
              </Link>
              <Link to="/solutions/incubator" className="dropdown-item">
                Incubator
              </Link>
              <Link to="/solutions/accelerator" className="dropdown-item">
                Accelerator
              </Link>
              <Link to="/solutions/angel" className="dropdown-item">
                Angel Investor
              </Link>
              <Link to="/solutions/vc" className="dropdown-item">
                VC
              </Link>
            </div>
          </div>

          <Link to="/how-prufyy-works" className="header-link">
            How Prufyy Works
          </Link>

          <Link to="/pricing" className="header-link">
            Pricing
          </Link>
        </nav>
      </div>

      {/* RIGHT SIDE */}
      <div className="header-right">
        <Link to="/login" className="header-link">
          Login
        </Link>

        <Link to="/signup" className="header-button">
          Sign up
        </Link>
      </div>
    </header>
  );
}

export default Header;
